export const SECTIONS = {
  AFFORDABLE_OVERVIEW: {
    DESCRIPTION:
      'Let prospects know the guidelines and details of the Affordable housing program for this property. This may include income limits, eligibility criteria, or rent restrictions.',
    TITLE: 'Program Overview & Details',
  },
  APPLICATION_INFO: {
    DESCRIPTION: 'Application process and requirements.',
    TITLE: 'Application Info',
  },
  BASIC_FEES: {
    DESCRIPTION: 'Standard fees and deposits for new residents.',
    TITLE: 'Basic Fees and Deposits',
  },
  COMMUNITY: {
    DESCRIPTION: 'Shared features or services available to all residents.',
    TITLE: 'Community',
  },
  CONTACT_INFO: {
    DESCRIPTION:
      'Main contact details for leasing or management.',
    TITLE: 'Contact Info',
  },
  COST_COVERED: {
    DESCRIPTION: 'Specify which utilities are covered by the property.',
    TITLE: 'Costs Covered',
  },
  CROSS_SELL: {
    DESCRIPTION:
      'Set rules for referring alternative communities to prospects.',
    TITLE: 'Cross-Sell',
  },
  GC_REQUIREMENTS: {
    DESCRIPTION: 'Set the data fields that must be completed when adding a prospect to Knock CRM.',
    TITLE: 'GC Info Requirements',
  },
  HOURS: {
    DESCRIPTION:
      'Set your Office and Touring hours or mark as closed. You can also set temporary holiday hours.',
    TITLE: 'Hours',
  },
  FEATURED_AMENITIES: {
    DESCRIPTION:
      'Amenities marked as “Featured” help AI respond to questions about popular or standout amenities.',
    TITLE: 'Featured Amenities',
  },
  IN_UNIT: {
    DESCRIPTION: 'Amenities and details located inside an individual unit.',
    TITLE: 'In Unit',
  },
  INCOME_ELIGIBILITY: {
    DESCRIPTION:
      'Enter the maximum allowable income for each household size to define eligibility for affordable housing at this property.',
    TITLE: 'Household Income Eligibility',
  },
  SELF_GUIDED_TOURS: {
    DESCRIPTION: 'Requirements and settings for Self-Guided tours.',
    TITLE: 'Self-Guided Tours',
  },
  LEASING_TERMS: {
    DESCRIPTION: 'Available lease terms and conditions.',
    TITLE: 'Leasing Terms',
  },
  MARKETING_MEDIA: {
    DESCRIPTION: 'Website, branding, photos, and social media info.',
    TITLE: 'Marketing & Media',
  },
  NOTES_FEATURES: {
    DESCRIPTION:
      'Extra details, unique features, or helpful notes for prospects and agents.',
    TITLE: 'Notes & Features',
  },
  PARKING_FEES: {
    DESCRIPTION: 'Add details about parking types and monthly costs.',
    TITLE: 'Parking Fees',
  },
  PET_POLICY: {
    DESCRIPTION: 'Detailed pet costs, policies and restrictions.',
    TITLE: 'Pet Policy',
  },
  PROPERTY_DETAILS: {
    DESCRIPTION: "Basic info about the property's location and key specs.",
    TITLE: 'Property Details',
  },
  PROPERTY_SERVICES: {
    DESCRIPTION:
      "On-site services provided to support residents' overall living experience. Costs associated with services can be added in the Leasing section.",
    TITLE: 'Property Services',
  },
};
